import ProbabilityOfDefault from "pages/underwriters/components/probabilityOfDefault";

export default function UnderwriterInsightsPD() {
    return (
        <ProbabilityOfDefault isUnderwriterInsights />
    )
}